import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';
import RocketEmblem from '../../../Assets/rocket-emblem.svg';
import RocketEmblemTwo from '../../../Assets/rocket-emblem-2.svg';
import RocketEmblemThree from '../../../Assets/rocket-emblem-3.svg';
import RocketEmblemSmall from '../../../Assets/rocket-emblem-small.svg';

// Custom css
import classes from './rocketEmblem.module.css';

interface Props {
  className?: string;
  id?: string;
  svgItem?: number;
}

const RocketEmblemSvg = ({ className = '', id, svgItem }: Props) => {
  switch (svgItem) {
    case 2:
      return <RocketEmblemTwo id={id} className={`${classes.rocketEmblemBase} ${className || ''}`} />;
    case 3:
      return <RocketEmblemThree id={id} className={`${classes.rocketEmblemBase} ${className || ''}`} />;
    case 4:
      return <RocketEmblemSmall id={id} className={`${classes.rocketEmblemBase} ${className || ''}`} />;

    default:
      return <RocketEmblem id={id} className={`${classes.rocketEmblemBase} ${className || ''}`} />;
  }
};

RocketEmblemSvg.defaultProps = {
  svgItem: 1,
  className: undefined,
  id: undefined,
};

const RocketEmblemSvgMemo = memo(RocketEmblemSvg, areEqualShallow);

export { RocketEmblemSvgMemo as RocketEmblemSvg };
